import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import BestParaquatLawyersWrapper from "@components/layouts/bestparaquatlawyersWrapper";

export default function BestParaquatLawyersHome(): ReactElement {
    return (
        <BestParaquatLawyersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Paraquat"
                    domain="BestParaquatLawyers.com"
                />
            </div>
        </BestParaquatLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
